export default __webpack_public_path__ + "static/5Oxygen-Customer-Brochure-Final-7e7a7d5e73f57733f6f100fe06ba1a52.pdf";